<ion-card color="getm-primary-default" mode="ios" class="promo-header">
  <ion-item
    color="transparent"
    mode="md"
    lines="none"
    class="item-header ion-text-center"
  >
    <section slot="start" class="back-button-section">
      <getm-button
        color="white"
        size="default"
        icon="arrow-back"
        shape="round"
        (btnClick)="onBack()"
      ></getm-button>
    </section>

    <ion-label color="getm-neutral-white" class="title-promo">
      <ion-text class="ellipsis">
        {{ promoDetail.title }}
      </ion-text>

      <ion-text
        class="available-and-ends"
        [innerHTML]="
          'Labels.available-and-ends' | translate : promoDetail | htmlSeguro
        "
      ></ion-text>
    </ion-label>

    <section slot="end" class="info-button-section">
      <getm-button
        color="primary"
        size="default"
        icon="getm-information-outline"
        shape="round"
        (btnClick)="onInfoClick()"
      ></getm-button>
    </section>
  </ion-item>

  <ion-card-content mode="md" class="content-levels">
    <ng-container *ngIf="promoDetail.tipoPromo === 'DINAMICO'; else escalera">
      <getm-level-step-badge
        [Niveles]="niveles"
        [level]="level"
        [isEditing]="isEditing"
        [isEditingLocked]="isEditingLocked"
        (levelClick)="onLevelClick($event)"
      ></getm-level-step-badge>

      <ion-item
        color="transparent"
        mode="md"
        lines="none"
        class="ion-text-center item-you-added-boxes"
      >
        <ion-label
          color="getm-neutral-white"
          class="you-added-boxes"
          [innerHTML]="
            'Labels.you-added-boxes' | translate : promoDetail | htmlSeguro
          "
        >
        </ion-label>
      </ion-item>
    </ng-container>

    <ng-template #escalera>
      <getm-discount-level-badge
        [Niveles]="niveles"
        [level]="level"
      ></getm-discount-level-badge>
    </ng-template>
  </ion-card-content>
</ion-card>
